<template>
  <div>
    <a-spin class="page-load" v-if="pageLoad"/>
    <div class="record-depot" v-else>
      <div class="main-box">
        <div class="result-count">
          <span>共<b>{{rowCount}}</b>个</span>
          <div class="sort">
            <span :class="sorts[0]?'down':''" @click="onSorts(0)">唱片数</span>
            <span :class="sorts[1]?'down':''" @click="onSorts(1)">名称</span>
          </div>
        </div>
        <div class="company-list">
          <div v-for="(item,index) in recordList" :key="'recordList'+index" class="company-cell">
            <div class="index">{{index+1}}</div>
            <div class="pic">
              <router-link :to="'/company-detail/'+encodeURIComponent(item['@id'])">
                <img v-if="item.img" :src="item.img" alt="" />
                <div v-else-if="item.nameChs" 
                  :class="'base-pic-placeholder bg'+parseInt(Math.random()*6)">
                  {{item.nameChs.substring(0,1)}}
                </div>
              </router-link>
            </div>
            <div class="info"> <router-link :to="'/company-detail/'+encodeURIComponent(item['@id'])">
              <div class="name" v-if="item.nameChs">
               
                  {{item.nameChs}}
               
              </div>
              <div class="des" v-if="item.description">
               {{
                  Array.isArray(item.description)
                    ? item.description[0].substring(0,item.description.lastIndexOf('(')).replace(/[.]/g,'。').replace(/,/g,'，')
                    :  item.description.substring(0,item.description.lastIndexOf('(')).replace(/[.]/g,'。').replace(/,/g,'，')
                }}
              </div>
              <div class="mb-count" v-if="item.phonoAmt">{{item.phonoAmt}}唱片</div>
               </router-link>
            </div>
            <div class="count-c" v-if="item.phonoAmt">
            <b>{{item.phonoAmt}}</b>唱片
          </div>
            <div class="act">
              <span :class="item.isFavorite?'fav cur':'fav'" @click="handleFav(index)"></span>
            </div>
          </div>
        </div>
        <div class="page-box">
          <a-pagination 
          :total="pagerCount" 
          :current="currentPage" 
          @change="onChange"  
          show-quick-jumper show-less-items />
        </div>
      </div>
    </div>
    <Player />
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from '@/components/player';
import { orgSearch,collFav,ncollFav,collOrgList } from "@/api";

export default {
  components: {
    Nav,
    Footer,
    Player
  },
  data(){
    return {
      pageLoad:false,
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {}, // 检索参数
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      recordList:[],
      showAll:[true,true,false,false,false,false],
      filterKeys:[],
      isFav:false,
      sorts:[true,false,false]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.query();
    });
  },
  methods:{
    initData () { // 初始化
      this.recordList = [];
      this.rowCount = 0;
    },
    onParamsHandle() { // 检索参数设置
      // 初始化
      this.initData();
      this.searchParams = this.commonParamsHandling();
      // 排序
      this.searchParams.sorts = {};
      if(this.sorts[0]) this.searchParams.sorts.CNT = 0;//数量倒排
      if(this.sorts[1]) this.searchParams.sorts.NAME = 1;
      // 页码
      this.searchParams.pager.pageth = this.currentPage;
      if(this.filterKeys.length < 1) return;
      let sim = false;
      this.filterKeys.forEach((item,index)=>{
        const dict = item.dict;
        // 简单检索
        if(dict == 'keyword') {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if(dict.indexOf('Dict') != -1){
          this.searchParams.facet[dict.replace('Dict','').toUpperCase()] = item.text;
        }
      })
      
    },
    async query() { // 查询
      // 参数设置
      // this.pageLoad = true;是否刷新画面
      this.onParamsHandle();
      const res = await collOrgList(this.searchParams);
      if(res){
        this.pageLoad = false
      }
      const result = res.data;
      this.recordList = result.datas;
      // 总数
      this.rowCount = result.pager.rowCount;
      // 页码
      this.pagerCount = result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
      //console.log(result);
    },
    onCountHnadle(key) { // 统计数量
      this[key+'Count'] = 0;
      this[key+'Dict'].forEach((item, index)=>{
        this[key+'Count'] += item.count;
      })
    },
    async handleFav(index){
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$message.open({
          content: "您还未登录,登陆后才能操作",
        });
        return;
      }
      const res =this.recordList[index].isFavorite ? await ncollFav({uri:this.recordList[index]['@id']}) :  await collFav({uri:this.recordList[index]['@id']}) ;
      //console.log(res)

      this.recordList.splice(index,1,{
        ...this.recordList[index],
        isFavorite:!this.recordList[index].isFavorite
      })
      this.isFavorite = !this.isFavorite
     
      this.$parent.coll(this.recordList[index].isFavorite);
      this.query()
    },
    onSorts(n) { // 排序
      // 排序
      this.sorts.splice(n, 1, !this.sorts[n]);
      let allFalse = 1
      this.sorts.forEach((item, index) => {
        if (n != index) {
          this.sorts[index] = false;
        }
        if(item == true){
          allFalse = 2
        }
      });
      if(allFalse == 1){
        this.sorts[0] = true;
      }
      this.query(false);
    },
    onChange (current) { // 页码点击
      this.currentPage = current;
      this.query(false);
    },
  }
}
</script>
